import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';

import { debounce } from '@utils';

import { Field, Icon } from '@components/Shared';

import { PlatformAppsTemplatesFilters } from './PlatformAppsTemplatesFilters';

export const PlatformAppsTemplatesHeader: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const searchParam = searchParams.get('search') || '';

  const [search, setSearch] = useState(searchParam);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((value: string) => {
      const newParams = new URLSearchParams(searchParams.toString());

      if (value) {
        newParams.set('search', value);
      } else {
        newParams.delete('search');
      }

      setSearchParams(newParams);
    }, 400),
    [],
  );

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    debouncedSearch(value);
    setSearch(value);
  };

  return (
    <>
      <Field.Input
        placeholder="Search..."
        value={search}
        onChange={handleSearchChange}
        labelVariant="static"
        variant="smaller"
        containerClassName="flex-1 relative"
        className="border-neural-03"
      >
        <Icon
          slot="icon"
          size="lg"
          icon={faMagnifyingGlass}
          className="absolute inset-y-0 left-4 m-auto text-neural-04 peer-focus:text-primary"
        />
      </Field.Input>
      <PlatformAppsTemplatesFilters />
    </>
  );
};
